import Vue from 'vue';
import Dropdown from 'components/Butterfly/Dropdown/Dropdown.vue';
import DropdownItem from 'components/Butterfly/Dropdown/DropdownItem.vue';
export default Vue.extend({
    components: { Dropdown, DropdownItem },
    props: {
        /** Currently selected value */
        value: { type: String, default: '' },
        /** Options to display; Array of `{ label: String, value: String|Number }` */
        options: { type: Array, default: () => [] },
        /** Text to display when no value is selected */
        placeholderText: { type: String, default: "No value selected..." },
        /** Label truncation width */
        truncationLengthSelected: { type: Number, default: 50 },
        truncationLengthInDropdown: { type: Number, default: 80 },
    }
});
